import React from 'react';
import { Container } from 'react-bootstrap';

function SuccessText() {

  const captionStyleheader = {
    textAlign: 'center',
    padding: '2px',
    marginTop: '2rem',
    marginBottom: '4rem', // Adjusted for better spacing
  };

  const captionTextStyle = {
    fontSize: '1.2rem',
    fontWeight: 600,
    textAlign: 'center',
    lineHeight: '2.5', // Adjusted for better readability
    marginBottom: '2rem',
    padding:'20px',
    
  };
  // const captionTextStyleP = {
  //   fontSize: '1.1rem', 
  //   width:'100%' ,
  //   textAlign:'center',
  //   fontWeight: 700
  // }
  return (
    <Container
    fluid
      style={{
        marginBottom: '10px',
        height: 'auto',
        marginTop: '10px',
      }}
    >
      <Container className="d-flex align-items-center justify-content-center" style={{ marginTop: '30px'}}>
          {/* <h1 className="text-lg" style={captionTextStyleP}>Discover real stories of success and satisfaction</h1> */}
        </Container>
      <Container style={{ padding: '1px', ...captionStyleheader }}>
        <p className="lead" style={captionTextStyle}>
        Discover real stories of success and satisfaction, where each narrative unveils the power of dedication and the impact of personalized support, illuminating the path to achievement and fulfillment for all involved.
        </p>
      </Container>
    </Container>
  );
}

export default SuccessText;
